module.exports = __webpack_public_path__ + "static/media/Neo.b719d7c8.jpg";